export const CONTENT_TYPE = {
    JSON: 'json',
    FORM: 'form'
};
